export const enum Path {
  // Contents paths
  INDEX = "/",
  LOGIN = "/login",
  SIGNUP = `/signup`,
  LOGIN_CAFE24 = "/login/cafe24",
  SIGNUP_CAFE24 = "/api/platform/cafe24",
  LOGIN_APP = "/settings",
  FIND_PASSWORD = "/find-password",
  DASHBOARD = "/",
  WIDGET_INTEGRATION = "/widget/integration",
  WIDGET_SETTINGS = "/widget/settings",
  WIDGET_EMBED = "/widget/embed",
  WIDGET_STUDIO = "/widget/studio",
  SHOP_INFO = "/shop-info",
  SUBSCRIBE = "/subscribe",
  PAYMENT_METHOD = "/billing/payment-method",
  PAYMENT_ADMIN = `/billing/admin`,
  PAYMENT_HISTORY = `/billing/history`,
  EDITOR = "/editor",
  POSTINGS = "/postings",
  POSTING_GROUPS = "/posting-groups",
  SHOP_SETTINGS = "/settings/shop",
  ACCOUNT_SETTINGS = "/settings/account",
  GUIDE = "/guide",
}
